import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  requiredValidationMessage: {
    id: 'QEoTU2',
    defaultMessage: 'This field is required',
    description: 'Field is required validation message',
  },
});
